<template>
	<div class="pricingwrap" id="pricingwrap">
		<iframe name='iframe_pricing' id="iframe_pricing" src="./static/pricing/index.html" scrolling="no" style="width: 100%;height: 100%;" frameborder="0" marginheight="0" marginwidth="0" width="100%" height=""></iframe>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		created(){},
		mounted() {
			this.$nextTick(function(){
				let demo=document.getElementById('demo');
				demo.className = 'el-menu-item'
				demo.style.color='rgb(255, 255, 255)';
				demo.style.borderBottomColor='transparent';
			});
		},
		beforeUpdate(){},
		methods:{}
	}
</script>

<style>
	.pricingwrap{
		height: 100%;
		width: 100%;
	}
	#iframe_pricing{
		vertical-align:bottom;
	}
</style>


// WEBPACK FOOTER //
// src/views/pricingPage.vue